import React from 'react'

const About = () => {

    return (
        <>

            <div className='container p-5'>
                <h3>Our Website contains different variety of Products.</h3>
                <p>This product are availble with very minimum price <br></br>
                    You can view our products on New Arrival.
                </p>
            </div>

        </>
    )

}

export default About